class a extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M14.63 3.127a3 3 0 0 0-4.25 0l.71.71a2.005 2.005 0 0 1 2.835 2.835l-4 4a2.003 2.003 0 0 1-2.835-2.83l.705-.71-.705-.71-.71.71a3 3 0 0 0 0 4.25 3 3 0 0 0 2.125.866 3 3 0 0 0 2.135-.88l4-4a3 3 0 0 0-.01-4.24Z"></path><path d="M2.1 12.158a2.001 2.001 0 0 1 0-2.836l4-4a2 2 0 0 1 2.835 0 1.97 1.97 0 0 1 .57 1.425 2 2 0 0 1-.585 1.425L7.86 9.247l.71.71 1.06-1.06a3.009 3.009 0 0 0-4.255-4.255l-4 4a3 3 0 0 0 0 4.256 3 3 0 0 0 2.13.85 3.04 3.04 0 0 0 2.14-.88l-.71-.71a2 2 0 0 1-2.835 0Z"></path></svg>';
  }
}
const t = "pi-link";
customElements.get(t) || customElements.define(t, a);
export {
  a as default
};
